import { SVGProps } from "react";

export default function PostDiscussionIcon(props: SVGProps<SVGSVGElement>) {
  const {
    height = 20,
    width = 20,
    stroke = "#444D5A",
    strokeWidth = 1.5,
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.3922 14.0253L15.7172 16.6587C15.8005 17.3503 15.0589 17.8336 14.4672 17.4753L10.9755 15.4003C10.5922 15.4003 10.2172 15.3753 9.85053 15.3253C10.4672 14.6003 10.8339 13.6836 10.8339 12.692C10.8339 10.3253 8.78386 8.40868 6.25052 8.40868C5.28386 8.40868 4.39219 8.68366 3.65053 9.16699C3.62553 8.95866 3.61719 8.75032 3.61719 8.53365C3.61719 4.74198 6.90886 1.66699 10.9755 1.66699C15.0422 1.66699 18.3339 4.74198 18.3339 8.53365C18.3339 10.7837 17.1755 12.7753 15.3922 14.0253Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8307 12.6915C10.8307 13.6832 10.4641 14.5999 9.8474 15.3249C9.0224 16.3249 7.71406 16.9665 6.2474 16.9665L4.0724 18.2582C3.70573 18.4832 3.23906 18.1748 3.28906 17.7498L3.49739 16.1082C2.38073 15.3332 1.66406 14.0915 1.66406 12.6915C1.66406 11.2248 2.4474 9.93318 3.6474 9.16651C4.38907 8.68318 5.28073 8.4082 6.2474 8.4082C8.78073 8.4082 10.8307 10.3248 10.8307 12.6915Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
